import { render, staticRenderFns } from "./IconMenuCog.vue?vue&type=template&id=6b8d63da"
import script from "./IconMenuCog.vue?vue&type=script&lang=js"
export * from "./IconMenuCog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports